import { useCallback, useRef } from 'react'
import cx from 'classnames'
import styles from './SearchBar.module.css'
import { Icon } from '@/components/Icon'
import { IconButton } from '@/components/IconButton'
import { Tooltip } from '@/components/Tooltip'

export interface SearchBarProps {
  searchText: string
  onSearchTextChange: (value: string) => void
  canManageTeamMember: boolean
  onInvite: () => unknown
}

export function SearchBar({
  searchText,
  onSearchTextChange,
  canManageTeamMember,
  onInvite,
}: SearchBarProps) {
  const searchFieldRef = useRef<HTMLInputElement>(null)
  const onSearchBar = useCallback(() => searchFieldRef.current?.focus(), [])

  return (
    <div className={styles.root}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- mouse-only convenience that focuses the nested input, which is itself keyboard reachable */}
      <div className={styles.searchBar} onClick={onSearchBar}>
        <div className={styles.searchIcon}>
          <Icon name="search" />
        </div>
        <input
          ref={searchFieldRef}
          type="text"
          placeholder="Search Members"
          className={cx(styles.searchField, !searchText && styles.empty)}
          value={searchText}
          onChange={(e) => onSearchTextChange(e.target.value)}
        />
      </div>
      <div className={styles.filterContainer}>
        {canManageTeamMember && (
          <Tooltip content="Invite New Member">
            <IconButton
              name="add"
              label="Invite New Member"
              onPress={onInvite}
              className={styles.icon}
            />
          </Tooltip>
        )}
      </div>
    </div>
  )
}
